import { assign } from 'fsm';
import I18n from 'I18n';
import Raven from 'raven-js';
import { fetchObjectLabels } from './client';
export const machine = {
  initial: 'loading',
  states: {
    loading: {
      invoke: {
        src: 'fetchObjectLabels',
        onDone: {
          target: 'idle',
          actions: ['setObjectLabels']
        },
        onError: {
          target: 'idle',
          actions: ['addLoadingError', 'logError']
        }
      },
      tags: ['loading']
    },
    idle: {}
  },
  actions: {
    addLoadingError: context => {
      var _context$addAlertDang;
      (_context$addAlertDang = context.addAlertDanger) === null || _context$addAlertDang === void 0 || _context$addAlertDang.call(context, {
        message: I18n.text('enrichmentProperties.settings.fetchingError.message'),
        titleText: I18n.text('enrichmentProperties.settings.fetchingError.title')
      });
    },
    logError: (_context, event) => {
      const {
        responseJSON
      } = event.data;
      Raven.captureException(responseJSON !== null && responseJSON !== void 0 ? responseJSON : JSON.stringify(event));
    },
    setObjectLabels: assign((_context, event) => {
      return {
        companyLabels: event.data.companyLabels,
        contactLabels: event.data.contactLabels
      };
    })
  },
  services: {
    fetchObjectLabels
  }
};